import React, { FC } from 'react';
import styled from 'styled-components';

import { getPosts } from '~/feature/blogs/blog.data';
import { blogSelector } from '~/feature/blogs/blog.selector';
import { EmptyPostCard } from '~/feature/blogs/EmptyPostCard';
import { ViewPostCard } from '~/feature/blogs/ViewPostCard';
import { Pagination } from '~/feature/pagination/Pagination';
import { useAppDispatch, useAppSelector } from '~/store';

// TODO: Разделить компонент.
export const BlogsPage: FC = () => {
  const dispatch = useAppDispatch();

  const { isGetPostsLoading, posts } = useAppSelector(blogSelector);

  return (
    <SCBlogsPage>
      {isGetPostsLoading ? (
        <>
          <EmptyPostCard />
          <EmptyPostCard />
          <EmptyPostCard />
        </>
      ) : posts.map((post) => (
        <ViewPostCard
          key={post.id}
          post={post}
        />
      ))}
      <SCPagination
        onChange={() => {
          dispatch(getPosts({}));
        }}
      />
    </SCBlogsPage>
  );
};

const SCBlogsPage = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

const SCPagination = styled(Pagination)`
  display: flex;
  justify-content: center;
`;
